"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/parse-int"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icon = _interopRequireDefault(require("../icon/icon"));

var _button = _interopRequireDefault(require("../button/button"));

var _utils = require("../lib/utils");

var iconSizes = {
  lg: 48,
  md: 32
};

var RegularMessageBox = function RegularMessageBox(_ref) {
  var size = _ref.size,
      icon = _ref.icon,
      primaryText = _ref.primaryText,
      secondaryText = _ref.secondaryText,
      action = _ref.action,
      isHtml = _ref.isHtml;
  var iconWidth = iconSizes[size];
  var iconHeight = iconSizes[size];

  if ((0, _utils.hasProperty)(icon, "width")) {
    iconWidth = (0, _parseInt2["default"])(icon.width, 10);
    iconHeight = (0, _utils.hasProperty)(icon, "height") ? (0, _parseInt2["default"])(icon.height, 10) : iconWidth;
  } else if ( /*#__PURE__*/_react["default"].isValidElement(icon) && (0, _utils.hasProperty)(icon.props, "width")) {
    iconWidth = (0, _parseInt2["default"])(icon.props.width, 10);
    iconHeight = (0, _utils.hasProperty)(icon.props, "height") ? (0, _parseInt2["default"])(icon.props.height, 10) : iconWidth;
  }

  var iconClass = (0, _utils.gatherClasses)(null, "oui-mbx-icon", "oui-icon-".concat(size), icon.className || "");
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _utils.gatherClasses)(null, "oui-mbx-regular", "oui-mbx-".concat(size))
  }, icon ? /*#__PURE__*/_react["default"].isValidElement(icon) ? /*#__PURE__*/_react["default"].cloneElement(icon, {
    className: (0, _utils.gatherClasses)(null, "oui-mbx-icon", icon.props.className),
    width: iconWidth,
    height: iconHeight
  }) : /*#__PURE__*/_react["default"].createElement(_icon["default"], (0, _extends2["default"])({
    className: iconClass
  }, icon, {
    width: "".concat(iconWidth, "px"),
    height: "".concat(iconHeight, "px")
  })) : null, primaryText && /*#__PURE__*/_react["default"].createElement("div", {
    className: "oui-mbx-text-primary"
  }, primaryText), secondaryText && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _utils.gatherClasses)(null, "oui-mbx-text-secondary", !primaryText ? "oui-no-primary" : "")
  }, isHtml ?
  /*#__PURE__*/
  // eslint-disable-next-line react/no-danger
  _react["default"].createElement("div", {
    dangerouslySetInnerHTML: {
      __html: secondaryText
    }
  }) : secondaryText), (0, _utils.isObject)(action) && action !== null && /*#__PURE__*/_react["default"].createElement("div", {
    className: "oui-mbx-message-action"
  }, /*#__PURE__*/_react["default"].createElement(_button["default"], {
    size: "sm",
    type: action.type === "link" ? "link" : "secondary",
    label: action.data && action.data.label,
    onClick: action.data && action.data.onClick,
    href: action.data && action.data.href,
    disabled: action.data.disabled
  })));
};

RegularMessageBox.defaultProps = {
  // eslint-disable-next-line react/default-props-match-prop-types
  size: "md",
  primaryText: "",
  secondaryText: ""
};
RegularMessageBox.propTypes = {
  size: _propTypes["default"].oneOf(["lg", "md"]).isRequired,
  icon: _propTypes["default"].shape(_icon["default"].propTypes).isRequired,
  primaryText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
  secondaryText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
  secondary: _propTypes["default"].string,
  className: _propTypes["default"].string,
  action: _propTypes["default"].shape({
    type: _propTypes["default"].oneOf(["button", "link"]).isRequired,
    data: _propTypes["default"].shape({
      label: _propTypes["default"].string.isRequired,
      href: _propTypes["default"].string,
      onClick: _propTypes["default"].func,
      disabled: _propTypes["default"].bool
    })
  }),
  isHtml: _propTypes["default"].bool
};
RegularMessageBox.displayName = "OrionMessageBoxRegular";
var _default = RegularMessageBox;
exports["default"] = _default;